<template>
  <div style="height:100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="saleOrderCopackingRef" :fields="fields" :title="table_title.title1"
        :show_query_container="false" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="true" :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" :hb_table_class="'hb_table_so_class1'" @state_change="state_change"
        :show_toolbar_button="[1, 1, 0, 0, 0]" :isBusy="isBusy_table1" :loading_width="50" @tool_invoke="tool_invoke"
        @current_changed="current_changed" tableref="e302d08196ba4b27b7326b01769779b4">
        <template #toolbar>
          {{ $t("common.create_date") }}:
          <el-date-picker class="ml-2" size="small" style="width: 220px" v-model="date_range" type="daterange"
            align="right" unlink-panels range-separator="-" start-placeholder="" end-placeholder=""
            :picker-options="pickerOptions()">
          </el-date-picker>
          <el-tooltip content="刷新数据" placement="top" effect="light">
            <el-button type="info" plain @click="getCopackingData" style="width: 55px" class="ml-2 fa fa-refresh"
              size="mini"></el-button>
          </el-tooltip>
          <el-checkbox :label="$t('common.show_only_valid')" v-model="onlyValid" class="ml-4"
            @change="filterData()"></el-checkbox>
          <el-checkbox :label="$t('common.has_excuted')" v-model="onlyNoCopacking" class="ml-2"
            @change="filterData()"></el-checkbox>
        </template>
        <template #operation>
          <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="saveCopacking"
            :label="$t('common.save')" class="ml-2">
          </QueryButton>
        </template>
      </TableMain>
    </BaseContainer>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import * as SalesOrderCopackingController from "../../controllers/sd/SalesOrderCopackingController"
import QueryButton from "../components/base/QueryButton"
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"
export default {
  name: "saleOrderDispatch",
  components: {
    QueryButton,
    BaseContainer,
    TableMain,
  },
  data() {
    return {
      fileList: [],
      table_title: {
        title1: "table_copacking",
      },
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      fields: SalesOrderCopackingController.fields.default,
      hisDataList: [],
      date_range: "",
      isBusy_table1: false,
      onlyValid: true,
      onlyNoCopacking: false
    }
  },
  created() {
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
    this.date_range = [start, end]
    this.getCopackingData()
  },
  methods: {
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit("pick", [start, end])
            },
          },
        ],
      }
    },
    async getCopackingData() {
      this.isBusy_table1 = true
      let p = {}
      let _fromDate = "",
        _toDate = ""
      if (!_.isNull(this.date_range)) {
        _fromDate = this.$date.format(this.date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(this.date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        // p["create_at"] = { ">=": _fromDate, "<=": _toDate };
        p["fromDate"] = _fromDate
        p["toDate"] = _toDate
      }
      let _result = await SalesOrderCopackingController.methods.getData(p)
      this.$refs.saleOrderCopackingRef.SetData([])
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.hisDataList = _result[0]
        this.filterData()
      }
      this.isBusy_table1 = false
    },

    async resetIdsData(ids) {
      let p = {}
      let _fromDate = "",
        _toDate = ""
      if (!_.isNull(this.date_range)) {
        _fromDate = this.$date.format(this.date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(this.date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        // p["create_at"] = { ">=": _fromDate, "<=": _toDate };
        p["fromDate"] = _fromDate
        p["toDate"] = _toDate
      }
      let _result = await SalesOrderCopackingController.methods.getData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.hisDataList = _result[0]
        for (var i in ids) {
          let m = _.find(_result[0], { id: ids[i] })
          if (m) {
            this.$refs.saleOrderCopackingRef.UpdateItems({ id: ids[i] }, m)
          }
        }

      }
    },
    //copacking
    async copackingMethod() {
      this.msgModal("确定要生成订单吗？").then(async (v) => {
        if (v) {
          let _gt_credit =
            await SalesOrderCopackingController.methods.pickAndInvoke(["070"])
          if (_gt_credit) {
            if (_gt_credit.status != 0) {
              this.msgToasts(this.$t("notify.ax_error") + "：" + _gt_credit.message, "error")
              return
            }
          } else {
            this.msgToasts(this.$t("notify.ax_call_failed"), "error")
            return
          }

          let _result =
            await SalesOrderCopackingController.methods.copackingMethod()
          if (_result) {
            this.msgToasts(this.$t("notify.action_successfully"), "success")
          } else {
            this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
          }
        }
      })
    },
    current_changed(old, current) { },
    tool_invoke(data) { },
    state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      let _state = data.state == "valid" ? true : false
      let is_state_ok = true
      _.each(data.selected_items, (t) => {
        if (!_.isNull(t.SalesLineNum) && t.SalesLineNum != "" && !_state) {
          is_state_ok = false
        }
      })
      if (!is_state_ok) {
        this.msgToasts("抱歉，已生成销售订单数据不能被禁用！", "info")
        cb(false)
        return
      }
      let st = _.filter(data.selected_items, { is_valid: _state })
      if (st && st.length > 0) {
        this.msgToasts("抱歉，已启用或禁用数据不能再次被启用或禁用！", "info")
        cb(false)
        return
      }
      let stateStr = _state ? "启用" : "禁用"
      this.msgModal("确定要" + stateStr + "吗？").then(async (v) => {
        if (v) {
          let result = await SalesOrderCopackingController.methods.updateCopackingData(data.selected_items, _state)
          if (!_.isNull(result)) {
            _.each(data.selected_items, (t) => {
              t.is_valid = _state
            })
            this.msgToasts(this.$t("notify.action_successfully"), "success")
            cb(true, false)
          } else {
            this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
            cb(false)
          }
          this.filterData()
        }
      })

    },
    ErrorMsg(data) {
      if (_.isNull(data.variantId)) {
        return ("<div>" + this.$t("common.customer") + ":" + "<strong>" + data.AccountNum + "</strong>" + "，" + this.$t("common.invent") + this.$t("common.num") + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t("common.variant_coding") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (_.isNull(data.customerName)) {
        return ("<div>" + this.$t("common.customer") + ":" + "<strong>" + data.AccountNum + "</strong>" + "，" + this.$t("common.invent") + this.$t("common.num") + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t("common.customer") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (_.isNull(data.companyName)) {
        return ("<div>" + this.$t("common.customer") + ":" + "<strong>" + data.AccountNum + "</strong>" + "，" + this.$t("common.invent") + this.$t("common.num") + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t("common.company") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (_.isNull(data.SalesPool)) {
        return ("<div>" + this.$t("common.customer") + ":" + "<strong>" + data.AccountNum + "</strong>" + "，" + this.$t("common.invent") + this.$t("common.num") + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t("common.sales_pool") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (data.existsRetailVariantId == 0) {
        return ("<div>" + this.$t("common.customer") + ":" + "<strong>" + data.AccountNum + "</strong>" + "，" + this.$t("common.invent") + this.$t("common.num") + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t("common.invent") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      return ""
    },
    //保存
    async saveCopacking(cb) {
      let data = []
      data = this.$refs.saleOrderCopackingRef.GetSelectedItems()
      if (data.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      let is_valid_ok = true
      let is_copacking = true
      let ids = []
      _.each(data, (t) => {
        ids.push(t.id)
        if (!t.is_valid) {
          is_valid_ok = false
        }
        if (!_.isNull(t.SalesLineNum) && t.SalesLineNum != "") {
          is_copacking = false
        }
      })
      if (!is_valid_ok) {
        this.msgToasts(this.$t("notify.has_valid_can_not_create_order"), "info")
        cb(false)
        return
      }
      if (!is_copacking) {
        this.msgToasts(this.$t("notify.sales_order_is_created"), "info")
        cb(false)
        return
      }
      this.msgModal(this.$t("notify.is_continue")).then(async (v) => {
        if (v) {
          // //检查数据是否已被修改
          // let check = await SalesOrderCopackingController.methods.getData({
          //   id: { in: ids },
          // });
          // let state = true;
          // if (check) {
          //   _.each(check[0], (t) => {
          //     if (!_.isNull(t.SalesLineNum) && t.SalesLineNum != "") {
          //       this.msgToasts(
          //         "编号:" + t.id + " 已copacking！请刷新后重试！",
          //         "info"
          //       );
          //       cb(false);
          //       state = false;
          //       return;
          //     }
          //   });
          // }
          // if (!state) {
          //   return;
          // }

          let _gt_credit =
            await SalesOrderCopackingController.methods.pickAndInvoke(["070"])
          if (_gt_credit) {
            if (_gt_credit.status != 0) {
              this.msgToasts(this.$t("notify.ax_error") + "：" + _gt_credit.message, "error")
              cb(false)
              return
            }
          } else {
            this.msgToasts(this.$t("notify.ax_call_failed"), "error")
            cb(false)
            return
          }
          const loading = this.$loading({
            lock: true,
            text: this.$t("notify.saveing"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          })
          let json = []
          _.each(data, (t) => {
            json.push({ id: t.id })
          })
          // console.log(JSON.stringify(json))
          // return
          let _result =
            await SalesOrderCopackingController.methods.copackingMethod(
              JSON.stringify(json)
            )

          if (_result && _result.length > 0) {
            if (_result[0][0].status == 0) {
              // this.$refs.saleOrderCopackingRef.RemoveItems(data);
              await this.resetIdsData(ids)
              this.msgToasts(this.$t("notify.action_successfully"), "success")
              cb(true)
            } else {
              let str = "<div><strong>" + this.$t("notify.create_failed_error") + ":</strong></div>"

              _.each(_result[0], (t) => {
                if (
                  _.isNull(t.customerName) ||
                  _.isNull(t.companyName) ||
                  _.isNull(t.dataAreaId) ||
                  t.dataAreaId == "" ||
                  _.isNull(t.variantId) ||
                  _.isNull(t.SalesPool) ||
                  t.existsRetailVariantId == 0
                ) {
                  console.log(t)
                  //标红错误行
                  str += this.ErrorMsg(t)
                }
              })
              this.msgToasts(str, "error", 0, true, "notify550")
              cb(false)
            }

            // let has_id_list = _.filter(_.cloneDeep(data), function (t) {
            //   return t.id != "";
            // });
            // if (has_id_list && has_id_list.length > 0) {
            //   let result = await SalesOrderController.methods.deleteItemData(
            //     has_id_list
            //   );
            // }
          } else {
            this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
            cb(false)
          }
          loading.close()
        } else {
          cb(false)
        }
      })
    },
    filterData() {
      let _lt = this.hisDataList
      if (!this.onlyValid && !this.onlyNoCopacking && _.isNull(this.date_range)) {
        this.$refs.saleOrderCopackingRef.SetData(_lt)
      }
      else {
        if (this.onlyValid) {
          _lt = _.filter(_lt, { is_valid: true })

        }
        if (this.onlyNoCopacking) {
          _lt = _.filter(_lt, (t) => {
            if (!_.isNull(t.SalesLineNum) && t.SalesLineNum != "") {
              return t
            }
          })
        }
        else {
          _lt = _.filter(_lt, (t) => {
            if (_.isNull(t.SalesLineNum) || t.SalesLineNum == "") {
              return t
            }
          })
        }
        this.$refs.saleOrderCopackingRef.SetData(_lt)
      }
    }
  },
}
</script>
<style>
.hb_table_so_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 180rem;
}
</style>
